import React, { useState } from 'react';
import clsx from 'clsx';
import Icon from '../Icon';

const timeAgo = (dateStr) => {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
};

const AgentFeed = ({ reports = [] }) => {
  const [prompt, setPrompt] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleAsk = () => {
    if (!prompt.trim()) return;
    setSubmitting(true);
    // TODO: wire to /api/compliance/agent/query — Phase 2 deliverable
    setTimeout(() => {
      setSubmitting(false);
      setPrompt('');
      // eslint-disable-next-line no-alert
      alert('Agent query submitted. In production, this calls Claude with your compliance context.');
    }, 600);
  };

  return (
    <div className="card full-width">
      <div className="row mb-4" style={{ justifyContent: 'space-between', flexWrap: 'wrap', gap: 'var(--s3)' }}>
        <div className="row row-gap-3">
          <Icon name="bell" size={18} style={{ color: 'var(--teal)' }} />
          <div className="card-title" style={{ margin: 0 }}>Compliance agent feed</div>
        </div>
        <div className="row row-gap-2">
          <button type="button" className="btn btn-outline" onClick={() => alert('Triggering hourly compliance scan…')}>
            Run hourly scan
          </button>
          <button type="button" className="btn btn-primary" onClick={() => alert('Generating EOD compliance report…')}>
            Generate EOD report
          </button>
        </div>
      </div>

      <div style={{ maxHeight: 360, overflowY: 'auto', paddingRight: 'var(--s2)', marginBottom: 'var(--s4)' }}>
        {reports.length === 0 && (
          <div className="empty">
            <div className="empty-icon"><Icon name="bell" size={26} /></div>
            <h3>No reports yet</h3>
            <p>The compliance agent runs hourly and at end-of-day. Reports will appear here.</p>
          </div>
        )}
        {reports.map((report, i) => {
          const isEOD = report.report_type === 'eod';
          return (
            <div
              key={report.id || i}
              className={clsx('agent-card', isEOD && 'warning')}
              style={{ animationDelay: `${i * 60}ms` }}
            >
              <div className="agent-time">
                <span className={clsx('badge', isEOD ? 'badge-warning' : 'badge-info')} style={{ marginRight: 8 }}>
                  {isEOD ? 'EOD' : 'Hourly'}
                </span>
                {new Date(report.created_at).toLocaleString()} · {timeAgo(report.created_at)}
              </div>
              <div className="agent-text">{report.summary_text}</div>
            </div>
          );
        })}
      </div>

      <div style={{ borderTop: '1px solid var(--bd)', paddingTop: 'var(--s4)' }}>
        <div className="text-xs mb-2" style={{ color: 'var(--tx3)', textTransform: 'uppercase', letterSpacing: '0.08em', fontWeight: 700 }}>
          Ask the agent
        </div>
        <div className="row row-gap-2">
          <input
            type="text"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleAsk()}
            placeholder="e.g. show me all structuring patterns from the last 48 hours…"
            disabled={submitting}
            style={{
              flex: 1,
              padding: '10px 14px',
              background: 'var(--bg-input)',
              border: '1px solid var(--bd)',
              borderRadius: 'var(--r-md)',
              color: 'var(--tx1)',
              fontSize: 13,
              outline: 'none',
              fontFamily: 'var(--font)',
              transition: 'border-color var(--tf) var(--ease)',
            }}
            onFocus={(e) => (e.currentTarget.style.borderColor = 'var(--bd-focus)')}
            onBlur={(e) => (e.currentTarget.style.borderColor = 'var(--bd)')}
          />
          <button type="button" className="btn btn-primary" onClick={handleAsk} disabled={submitting || !prompt.trim()}>
            {submitting ? 'Asking…' : 'Ask'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgentFeed;
